export const SAAS_FLAG = {
  /**  不是saas服务产品 */
  NO: 0,
  /** 是saas服务产品 */
  YES: 1,
}
